module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CulwCx/tc-custom/9781609451677.jpg?1704761315215",
      "alt": "This image is the cover for the book Three, Imperfect Number"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Three, Imperfect Number\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A blind woman leads her Naples police colleagues through the darkness in this distinctive crime thriller")]), _vm._v("."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A report has landed on Commissario Martusciello’s desk. The lifeless body of the singer Jerry Vialdi—aka Gennaro Mangiavento—has been found at the Naples football stadium; another corpse, this one a Jane Doe, has been discovered in the Bentegodi Stadium in Verona, hundreds of miles away."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The bodies were left in a fetal position and there are no signs of physical violence: The method and the madness behind it appear to hide some unutterable secret. Conclusion: a daring challenge left by a psychopath for the police—who are stabbing in the dark with no idea where to begin. All except for superintendent Blanca Occhiuzzi: Beautiful, blind from birth, forced by the dark that envelops her to perceive the world through only four senses, she feels the fear in people; she feels their guilt and their innocence. It is she who takes Martusciello by the hand, guiding him into the mind of a murderer . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patrizia Rinaldi, Antony Shugaar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patrizia Rinaldi lives and works in Naples, where she was born in 1960. She is the author of numerous works of crime fiction, all published in Italy. Three, Imperfect Number is her first work to appear in English.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0